/*!
* name ZJX 公共页签
* Copyright 2018-2019
*/
<template>
  <div class="public_nav">
    <div class="public_nav_tab">{{navName}}</div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  data () {
    return {
      navName: ''
    }
  },
  computed: {
    ...mapGetters(['navstate'])
  },
  mounted () {},
  methods: {},
  created () {
    this.navName = this.navstate == '' ? '个人信息' : this.navstate
  },
  watch: {
    $route (val, oldval) {
      console.log(val)
      console.log(oldval)
    }
  },
  props: {}
}
</script>

<style lang="scss" scoped>
.public_nav {
  height: 40px;
  border-bottom: 2px solid #15c1e4;

  .public_nav_tab {
    height: 40px;
    width: 120px;
    background: #15c1e4;
    line-height: 40px;
    text-align: center;
    font-size: 15px;
    color: #fff;
  }
}
</style>

